class Datalayer {
  constructor(ctx) {
    this.ctx = ctx
  }

  getDataLayerList() {
    const data = {
      page: {
        businessType: 'B2C',
        language: '',
        languageCode: '',
        section: '',
        webType: ''
      },
      user: {
        logged: false,
        profile: 'customer',
        cid: ''
      },
    }
    return data
  }

  setDatalayer(page, payload) {
    const events = {
      default(data) {
        const { page, user } = data.obj
        page.language = data.payload.mainConfig ? data.payload.mainConfig.analyticLang : ''
        page.languageCode = data.ctx.i18n.locale
        page.section = data.payload.content.meta.websection ? data.payload.content.meta.websection : ''
        page.webType = data.ctx.$device.isMobileOrTablet ? 'responsive' : 'notresponsive'

        const genderValue = data.ctx.store.state.nhAuth.userData.gender;
        const gender = Datalayer.genderCoincidence(genderValue);

        if (gender === null) {
          delete user.gender;
        } else {
          user.gender = gender;
        }
        
        user.logged = true
        user.tierRewards = data.ctx.store.state.nhAuth.userData.category
        user.profile = data.ctx.store.state.nhAuth?.userData?.programs
        ? data.ctx.store.state.nhAuth.userData.programs[0] === 'NH_DISCOVERY'
          ? 'MINOR_DISCOVERY'
          : data.ctx.store.state.nhAuth.userData.programs[0]
        : '';
        user.id = data.ctx.store.state.nhAuth.userData.partyId
        user.points = data.ctx.store.state.nhAuth.userData.bonusAmount
        const cookieGA = data.ctx.app.$cookies.get('_ga').split('.')
        user.cid = cookieGA[2] + '.' + cookieGA[3]

        return { page, user }
      }
    }

    const obj = this.getDataLayerList()

    try {
      const ctx = this.ctx
      const dataLayer = (events.default)({ obj, payload, ctx })
      this.sendDatalayer(dataLayer)
    } catch (error) {
      console.log('Error dataLayer page: ' + page + ' Error', error)
    }
  }

  sendDatalayer = (dataLayer) => {
    if (this.ctx.$lodash.isNil(dataLayer)) return
    window.nhDataLayer = dataLayer
  }

  static genderCoincidence(genderValue) {
    const genderListMale = ["Mr", "Herr", "Senor", "Monsieur", "Senhor", "1"];
    const genderListFemale = ["Mrs", "Ms", "Frau", "Senora", "Madame", "Mademoiselle", "Senhora", "2"];
    if (genderListFemale.includes(genderValue)) {
      return "female";
    } else if (genderListMale.includes(genderValue)) {
      return "male";
    } else {
      return null;
    }
  }

}

export default (ctx, inject) => {
  inject('Datalayer', new Datalayer(ctx))
}
